import {match} from 'ts-pattern';

import type {FlagSizeType} from './BaseFlagProps';

export const getFlagElementSizes = (size: FlagSizeType = 'default') =>
  match(size)
    .with(
      'large',
      () =>
        ({
          textSize: 'small',
          borderRadius: 'small',
          height: 8,
          labelHorizontalPadding: 3,
        }) as const
    )
    .with(
      'default',
      () =>
        ({
          textSize: 'small',
          borderRadius: 'small',
          height: 6,
          labelHorizontalPadding: 2,
        }) as const
    )
    .with(
      'small',
      () =>
        ({
          textSize: 'xSmall',
          borderRadius: 'xSmall',
          height: 4,
          labelHorizontalPadding: 1,
        }) as const
    )
    .exhaustive();
